import styles from './styles.module.scss';
import { Card } from './Card';
import { getChapterRecommendedProducts } from './getChapterRecommendedProducts';

export function ChapterList({ pagesFlow, colors, chapterIconMedia, showChapterIds, currentElements, fonts }) {
  const { allChapters, currentChapterId } = pagesFlow;
  const allChaptersWithoutCompletedChapters = allChapters.filter(item => !item.content.completedChaptersButtons);

  const showOtherChapters = allChaptersWithoutCompletedChapters.filter(chap => showChapterIds.includes(chap.id));

  return (
    <div className={styles.wrapper}>
      <div>
        {showOtherChapters?.map((chapter, idx) => {
          const { recommendedProductIds } = getChapterRecommendedProducts(chapter, pagesFlow);
          return (
            <Card
              key={chapter.id}
              chapter={chapter}
              chapterIndex={idx}
              chapterIconMedia={chapterIconMedia}
              currentChapterId={currentChapterId}
              currentElements={currentElements}
              colors={colors}
              pagesFlow={pagesFlow}
              recommendedProductIds={recommendedProductIds}
              fonts={fonts}
            />
          );
        })}
      </div>
    </div>
  );
}
